export const errorStatuses = {
  // HTTP 4xx - Клиентские ошибки
  400: 'Неверный запрос',
  401: 'Требуется авторизация',
  403: 'Доступ запрещен',
  404: 'Ресурс не найден',
  405: 'Метод не разрешен',
  408: 'Таймаут запроса',
  409: 'Конфликт данных',
  413: 'Слишком большой объем данных',
  414: 'Слишком длинный URL',
  415: 'Неподдерживаемый тип данных',
  422: 'Необрабатываемая сущность',
  429: 'Слишком много запросов',

  // HTTP 5xx - Серверные ошибки
  500: 'Внутренняя ошибка сервера',
  501: 'Не реализовано',
  502: 'Плохой шлюз',
  503: 'Сервис недоступен',
  504: 'Таймаут шлюза',
  505: 'Версия HTTP не поддерживается',
};
